/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Typography, Popover, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
	chartTitle: {
		color: '#1565c0',
		textAlign: 'center',
		fontWeight: '800',
		fontSize: '20px',
		margin: '15px 0px 10px 0px',
	},
	button: {
		marginTop: '10px',
		fontSize: '10px',
		letterSpacing: '1.5px',
		height: '25px',
		width: '85px',
	},
}));

const Evolution = (props) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const classes = useStyles();

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const anchorOrigin = {
		vertical: 'top',
		horizontal: 'center',
	};

	const paperProps = {
		style: {
			width: '500px',
			padding: '0px 10px 10px 10px'
		},
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	const chartData = {
		labels: props.weekEnd,
		datasets: [
			{
				id: 1,
				data: props.indicatorValues,
				fill: false,
				borderColor: 'rgb(21, 101, 192)',
				backgroundColor: 'rgb(21, 101, 192)',
				tension: 0.2,
			},
		],
	};

	const chartOptions = {
		legend: {
			display: false
		},
		scales: {
			xAxes: [{
				ticks: {
					fontSize: 10,
					fontStyle: 'bold',
				},
			}]
		}
	};

	return (
		<div>
			<Button aria-describedby={id} variant="contained" onClick={handleClick} className={classes.button}>
				EVOLUTION
			</Button>
			<Popover
				id={id}
				open={open}
				onClose={handleClose}
				anchorEl={anchorEl}
				anchorOrigin={anchorOrigin}
				transformOrigin={{
					vertical: 'bottom',
					horizontal: 'center',
				}}
				PaperProps={paperProps}
			>
				<Typography className={classes.chartTitle}>{props.indicator}</Typography>
				<Line
					data={chartData}
					options={chartOptions}
				/>
			</Popover>
		</div>
	);
};

export default Evolution;
